/**
 * Created by vaibhav on 31/3/18
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux"
import Helmet from 'react-helmet';
import Offerings from '../components/Offerings';
import Fade from 'react-reveal/Fade'
import ImagesCarousel from '../components/ImagesCarousel';
/*import PortraitCarousel from '../components/ImagesCarousel/carousel_portrait';*/
import ConnectedGridPortfolio from '../components/ConnectedGridPortfolio';
import ConnectedPortfolioLink from '../components/ConnectedGridPortfolio/ConnectedPortfolioLink';
import ConnectedImgLink from '../components/ConnectedImgLink';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Img from "gatsby-image";
import SvgEl from "./../components/SvgEl";
import config from './../../meta/config';
import LazyLoad from 'react-lazyload';
import * as actions from '../actions/portfolio';
import * as layoutActions from '../actions/layout';
import Link from "gatsby-link"
//import { gsap, TimelineMax } from "gsap"; // Also works with gsap and TimelineLite
import './style.css';
import { IntlProvider, addLocaleData } from 'react-intl'



// Locale data
/*
import enData from 'react-intl/locale-data/en'
import deData from 'react-intl/locale-data/de'
import ruData from 'react-intl/locale-data/ru'
*/
// Messages
import de from '../i18n/de.json'
import en from '../i18n/en.json'
import ru from '../i18n/ru.json'

const messages = { de, en, ru }

const breakpoint = {
    mobile: 727
};

const bowser = require('bowser');



export const HomePageTemplate = ({
                                     history,
                                     title,
                                     templateKey,
                                     heading,
                                     sub_heading_1,
                                     sub_heading_2,
                                     sub_heading_a1,
                                     sub_heading_a2,
                                     sub_heading_g1,
                                     sub_heading_g2,
                                     description,
                                     offerings,
                                     meta_title,
                                     meta_description,
                                     testimonials,
                                     language,
                                     grid,
                                     gridInfo,
                                     _setPortfolioId,
                                     showMainT,
                                     _showMainText,
                                     _hideMainText,
                                     pf_id,
                                     showModal,
                                     screenWidth,
                                     screenHeight,
                                     cover,
                                     browserDataName,
                                     browserSafari,
                                     osDataName,
                                     titles
                                 }) => (
    <div>
        <Helmet
        bodyAttributes={{
            class: templateKey + ' dct-' + browserDataName + ' dct-' + osDataName +  browserSafari
        }}
        >
            <html lang={language} />
            <title>{meta_title}</title>

            <meta name="description" content={meta_description}/>
            <meta name="image" content={config.siteUrl + cover}/>
            <meta property="og:url" content={config.siteUrl + config.pathPrefix}/>
            <meta property="og:type" content="article"/>
            <meta property="og:title" content={title}/>
            <meta property="og:description" content={meta_description}/>
            <meta property="og:image" content={config.siteUrl  + cover}/>
            <meta
                property="fb:app_id"
                content={config.siteFBAppID ? config.siteFBAppID : ""}
            />
        </Helmet>
        <Fade>

        <section id="intro" className="section section--gradient bg-sand">
            <div className="container">

                    <div className="columns">
                        <div className="column is-10 is-offset-1">
                        <h1 className="title title-section is-size-1 has-text-centered sand-dark" dangerouslySetInnerHTML={{ __html: heading }}/>
                        <h2 className="title-sub is-size-3 has-text-centered" dangerouslySetInnerHTML={{ __html: sub_heading_1 }}/>
                        <div className="intro_1_hr"><hr/></div>
                      <div className="has-text-centered intro_1" dangerouslySetInnerHTML={{ __html: messages[language].home_2 }}/>

                      </div>


                    </div>
            </div>
        </section>



        <section id="featured">
        <div className="columns">
            <div className="column is-10 is-offset-1 ">

                <h1 className="title title-section is-size-1 has-text-centered sand-dark">
                    {titles[0].t }
                </h1>
                <h2 className="title-sub is-size-3 has-text-centered">{titles[1].t }</h2>

        </div>
        </div>
        <ConnectedGridPortfolio data-set="Contern"
        history={history}
        screenWidth={screenWidth}
        screenHeight={screenHeight}
        showModal={showModal}
        pf_id={pf_id}
        data={grid.gridPicts}
        dataMobile={grid.gridPicts_mobile}
        dataInfo={gridInfo.grid}
        gallery={false}
        mobileCarousel={false}
        pictCount={4}
        mobilePictCount={2}
        morePos={0}
        moreTxt={messages[language].more}
        raster={[12, 4,4,4,3]}
        infoBox={[1, 0,0,0,0]}
        infoPos={[1, 0,0,0,0]}
        bottomSpace={[0, 0,0]}
        />
        <h3 className="labelInfo has-text-centered"><strong>Equestrian</strong> • Branding, UI/UX Design, Web Design</h3>

        <div className="content">
        <div className="column is-10 is-offset-1 ">


            <h2 className="title-sub is-size-3 has-text-centered">
            Work in progress
            </h2>

            <p className="has-text-left">
            Located on the eastern outskirts of Luxembourg City, the Contern Dressage Center is a private dressage horse training and breeding centre which upholds the highest standards of good horse-keeping and aims at high performance sport.
            </p>
            <p className="has-text-left">
            We first design the identity, then a clean website featuring the competiton horses, the team and the facility. The entire digital experience was carefully built to be full mobile responsive, across all screen sizes and optimized web browsers.
            </p>
            <h4>Services</h4>
            <ul className="_services">
            <li>Branding</li>
            <li>Web development</li>
            <li>Content Management</li>
            <li>Webdesign</li>
            <li>Search Engine Optimization</li>
            <li>Strategy</li>
            </ul>
        </div>
        </div>
        </section>



        <section id="featured_2">
        <ConnectedGridPortfolio data-set="msj"
        history={history}
        screenWidth={screenWidth}
        screenHeight={screenHeight}
        showModal={showModal}
        pf_id={pf_id}
        data={grid.gridPicts2}
        dataMobile={grid.gridPicts2_mobile}
        dataInfo={gridInfo.grid2}
        gallery={false}
        mobileCarousel={false}
        pictCount={3}
        mobilePictCount={2}
        morePos={0}
        moreTxt={messages[language].view}
        raster={[12,6,6]}
        infoBox={[1, 0,0, 0]}
        infoPos={[0, 0, 0, 0]}
        bottomSpace={[0, 0, 0, 0]}
        />
        <h3 className="labelInfo has-text-centered"><strong>Equestrian</strong> • UI/UX Design, Web Design</h3>

        <div className="content">
        <div className="column is-10 is-offset-1 ">
        <p className="gMehr has-text-centered"> <a href="https://www.mountstjohnequestrian.co.uk" target="_blank">+ Launch the website</a></p>

            <h2 className="title-sub is-size-3 has-text-centered">
            Website Relaunch
            </h2>
            <p className="has-text-left">
            Mount St. John is a private estate set in the beautiful North Yorkshire countryside in England. The stud specialises in breeding dressage horses of the highest standard. The company was in need of a long overdue redesign.
            </p>
            <p className="has-text-left">
            We developed a horse centric tool to maintain the live stock database and create listings without compromising the visual quality of the website.
            The entire digital experience was carefully built to be full mobile responsive, across all screen sizes and optimized web browsers.
            </p>

            <h4>Services</h4>
            <ul className="_services">
            <li>Web development</li>
            <li>Content Management</li>
            <li>Webdesign</li>
            <li>Search Engine Optimization</li>
            <li>Strategy</li>
            </ul>

        </div>
        </div>
        </section>

        <section id="featured_4">
        <ConnectedGridPortfolio data-set="LLM"
        history={history}
        screenWidth={screenWidth}
        screenHeight={screenHeight}
        showModal={showModal}
        pf_id={pf_id}
        data={grid.gridPicts4}
        dataMobile={grid.gridPicts4_mobile}
        dataInfo={gridInfo.grid4}
        gallery={false}
        mobileCarousel={false}
        pictCount={3}
        mobilePictCount={3}
        morePos={0}
        moreTxt={messages[language].view}
        raster={[12]}
        infoBox={[1]}
        infoPos={[0]}
        bottomSpace={[0]}
        />
        <h3 className="labelInfo has-text-centered"><strong>Hospitality</strong> • UI/UX Design, Web Design</h3>

        <div className="content">
        <div className="column is-10 is-offset-1 ">
        <p className="gMehr has-text-centered"> <a href="https://www.lilleymansion.com" target="_blank">+ Launch the website</a></p>

            <h2 className="title-sub is-size-3 has-text-centered">
            Hospitality Website
            </h2>
            <p className="has-text-left">
            The Lilley Mansion Bed & Breakfast, a once abandoned Victorian home, is officially welcoming guests.

            It’s been a journey for the Spring Lake historical structure. The 1875 mansion was rolled through town, underwent extensive renovations and opened during a pandemic.
            </p>
            <p className="has-text-left">
            Starting a Branding project from the very beginning is very exciting. We worked to bring Lilley Mansion new brand to life in a fully optimized web experience.
            </p>
            <h4>Services</h4>
            <ul className="_services">
            <li>Branding</li>
            <li>Web development</li>
            <li>Webdesign</li>
            <li>Search Engine Optimization</li>
            <li>Strategy</li>
            </ul>
        </div>
        </div>
        </section>

        <section id="featured_1">
        <ConnectedGridPortfolio data-set="book"
        history={history}
        screenWidth={screenWidth}
        screenHeight={screenHeight}
        showModal={showModal}
        pf_id={pf_id}
        data={grid.gridPicts1}
        dataMobile={grid.gridPicts1_mobile}
        dataInfo={gridInfo.grid1}
        gallery={true}
        mobileCarousel={false}
        pictCount={4}
        mobilePictCount={4}
        morePos={1}
        moreTxt={messages[language].more}
        raster={[6, 6, 6, 6]}
        infoBox={[0, 0, 1, 0]}
        infoPos={[0, 0, 1, 0]}
        bottomSpace={[0, 0, 0, 0]}
        />
        <h3 className="labelInfo has-text-centered"><strong>POLO Sport</strong> • Editorial Design, Concept, Layout & Production</h3>

        <div className="content">
        <div className="column is-10 is-offset-1 ">

            <h2 className="title-sub is-size-3 has-text-centered">
            Editorial design
            </h2>
            <p className="has-text-left">
            This beautiful table-book, impressive by its size and content, narrates how the Sport of Polo arrived in Spain, along 528 pages carefully designed in-house.
            </p>

            <h4>Services</h4>
            <ul className="_services">
            <li>Branding</li>
            <li>Editorial design</li>
            <li>Print production</li>
            <li>Graphic design</li>

            </ul>
        </div>
        </div>
        </section>

        <section id="featured_3">
        <ConnectedGridPortfolio data-set="branding"
        history={history}
        screenWidth={screenWidth}
        screenHeight={screenHeight}
        showModal={showModal}
        pf_id={pf_id}
        data={grid.gridPicts3}
        dataMobile={grid.gridPicts3_mobile}
        dataInfo={gridInfo.grid3}
        gallery={false}
        mobileCarousel={false}
        pictCount={5}
        mobilePictCount={2}
        morePos={0}
        moreTxt={messages[language].more}
        raster={[12, 3, 3, 3, ]}
        infoBox={[1, 0, 0, 0, 0]}
        infoPos={[0, 0, 0, 0, 0]}
        bottomSpace={[0, 0, 0, 0]}
        />
        <h3 className="labelInfo has-text-centered"><strong>Branding</strong> • Editorial Design, Graphic Design</h3>

        <div className="content">
        <div className="column is-10 is-offset-1 ">
        <p className="has-text-centered gMehr">
        <ConnectedPortfolioLink
        slug={ messages[language].links[3].u}
        label={messages[language].more}
        index={1}
        screenWidth={screenWidth}
        screenHeight={screenHeight}
        />
        </p>

            <h2 className="title-sub is-size-3 has-text-centered">
            Branding & Logotypes
            </h2>
            <p className="has-text-centered">
            Portfolio of Branding and Graphic design works.
            </p>

            <h4>Services</h4>
            <ul className="_services">
            <li>Branding</li>
            <li>Editorial design</li>
            <li>Print production</li>
            <li>Graphic design</li>

            </ul>
        </div>
        </div>
        </section>





        </Fade>

    </div>
);

HomePageTemplate.propTypes = {
    title: PropTypes.string,
    titles: PropTypes.array,
    meta_title: PropTypes.string,
    meta_description: PropTypes.string,
    templateKey: PropTypes.string,
    heading: PropTypes.string,
    description: PropTypes.string,
    offerings: PropTypes.shape({
        blurbs: PropTypes.array,
    }),
    grid: PropTypes.object,
    gridInfo: PropTypes.object,
    cover: PropTypes.string,
    _setPortfolioId: PropTypes.func,
    _showMainText:PropTypes.func,
    pf_id: PropTypes.string,
    showModal: PropTypes.bool,
};
/*
const HomePage = ({data}) => {
    const {frontmatter} = data.markdownRemark;
    const {siteMetadata} = data.site;

    return (
        <HomePageTemplate
            title={frontmatter.title}
            meta_title={frontmatter.meta_title}
            meta_description={frontmatter.meta_description}
            heading={frontmatter.heading}
            description={frontmatter.description}
            offerings={frontmatter.offerings}
            testimonials={frontmatter.testimonials}
            language={frontmatter.language}
            grid={data}
            cover={frontmatter.cover}
        />
    )
};
*/
class HomePage extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      pf_id: this.props.pf_id,
      showModal: this.props.modalVisible,
      browserData: '',
      osData: ''
    };

    this._setPortfolioId = this._setPortfolioId.bind(this);
    this._showMaintText = this._showMaintText .bind(this);

  }
  _showMaintText () {
    this.props.showMainText();
  }

  _setPortfolioId(event) {
    var xid = event.target.id.substring(1);

    this.setState({
     pf_id: xid
    });
    //send to the store, the portfolio id value
    this.props.setPortfolioId(xid);
  }

  componentDidMount() {
    const browser = bowser.getParser(window.navigator.userAgent);
    const browserData = browser.parsedResult.browser;
    const osData = browser.parsedResult.os;
    this.setState({
      browserData: browserData,
      osData: osData
    })
  }

  render() {

    const {frontmatter} = this.props.data.markdownRemark;
    const {siteMetadata} = this.props.data.site;

    var _titles = messages[frontmatter.language].titles
    var titles = []
    // transform object in array
    for (var key in _titles) {
    titles.push(_titles[key])
    }

    return (
      <HomePageTemplate
          history={this.props.history}
          title={frontmatter.title}
          templateKey={frontmatter.templateKey}
          browserDataName={this.state.browserData.name}
          osDataName={this.state.osData.name}
          browserSafari={this.state.browserData.name !== 'Safari' ? ' dct-not-Safari' : ''}
          meta_title={frontmatter.meta_title}
          meta_description={frontmatter.meta_description}
          heading={frontmatter.heading}
          sub_heading_1={frontmatter.sub_heading_1}
          sub_heading_2={frontmatter.sub_heading_2}
          sub_heading_a1={frontmatter.sub_heading_a1}
          sub_heading_a2={frontmatter.sub_heading_a2}
          sub_heading_g1={frontmatter.sub_heading_g1}
          sub_heading_g2={frontmatter.sub_heading_g2}
          description={frontmatter.description}
          offerings={frontmatter.offerings}
          testimonials={frontmatter.testimonials}
          language={frontmatter.language}
          grid={this.props.data}
          gridInfo={this.props.data.markdownRemark.frontmatter}
          cover={frontmatter.cover}
          _setPortfolioId={this._setPortfolioId}
          _showMainText={this.props.showMainText}
          _hideMainText={this.props.hideMainText}
          showMainT = {this.props.showMainT}
          pf_id={this.state.pf_id}
          showModal={this.state.showModal}
          screenWidth={this.props.screenWidth}
          screenHeight={this.props.screenHeight}
          raster={[6, 6, 4, 4, 4, 6, 6, 4, 4, 4, 4, 6, 6, 4, 4, 4,6, 6, 4, 4, 4,6, 6, 4, 4, 4]}
          titles = {titles}
          />
    )
  }
}

HomePage.propTypes = {
    pf_id: PropTypes.string,
    screenWidth: PropTypes.number.isRequired,
    screenHeight: PropTypes.number.isRequired,
    setPortfolioId: PropTypes.func,
    modalVisible: PropTypes.bool,
    showMainT: PropTypes.bool,
    showMaintText: PropTypes.func,
    hideMaintText: PropTypes.func,
    data: PropTypes.shape({
        markdownRemark: PropTypes.shape({
            frontmatter: PropTypes.object,
            siteMetadata: PropTypes.object
        }),
    }),
};


const mapStateToProps = ({ pf_id, lang, modalVisible, screenWidth, screenHeight, showMaintText, showMainT}) => {
  return { pf_id, lang, modalVisible, screenWidth, screenHeight, showMaintText, showMainT }
}

const mapDispatchToProps = dispatch => {
  return {
      // the action is accesible through props and will send to the store the id of the portfolio
      setPortfolioId: (v) => dispatch(actions.set_pf_id(v)),
      showMainText: () => dispatch(layoutActions.show_main_text()),
      hideMainText: () => dispatch(layoutActions.hide_main_text())
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage)

export const pageQuery = graphql`
  query IndexPage($id: String!) {
    site {
      siteMetadata {
        title
        dayOn
        dayOff
        closingDay
      }
    }
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        meta_title
        templateKey
        meta_description
        heading
        sub_heading_1
        sub_heading_2
        sub_heading_a1
        sub_heading_a2
        sub_heading_g1
        sub_heading_g2
        description
        language
        cover
        sketchImg
        portrait {
          image{
            src
            title
            sub_headline
            slug
          }
        }
        carousel {
          image{
            src
            title
            sub_headline
            slug
          }
        }
        grid {
          image{
            src
            title
            sub_headline
            slug
            external
            text
          }
        }
        grid1 {
          image{
            src
            title
            sub_headline
            slug
            external
            text
          }
        }
        grid2 {
          image{
            src
            title
            sub_headline
            slug
            external
            text
          }
        }
        grid3 {
          image{
            src
            title
            sub_headline
            slug
            external
            text
          }
        }
        grid4 {
          image{
            src
            title
            sub_headline
            slug
            external
            text
          }
        }
        offerings {
          blurbs {
            image
            text
          }
        }
      }
    }
    carouselPicts: allImageSharp(
      filter: { id: { regex: "/images/home-carousel/" } },
      sort: { order: ASC, fields: [id]}
    ) {
      edges {
        node {
          sizes(maxWidth: 1800,) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
    portraitPicts: allImageSharp(
      filter: { id: { regex: "/images/home-portrait/" } },
      sort: { order: ASC, fields: [id]}
  ) {
      edges {
        node {
          sizes(maxWidth: 800,) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
    gridPicts: allImageSharp(
      filter: { id: { regex: "/images/home-grid-000-desktop/" } },
      sort: { order: ASC, fields: [id]}
  ) {
      edges {
        node {
          sizes(maxWidth: 1400,) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
    gridPicts_mobile: allImageSharp(
      filter: { id: { regex: "/images/home-grid-000-mobile/" } },
      sort: { order: ASC, fields: [id]}
  ) {
      edges {
        node {
          sizes(maxWidth: 1400,) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
    gridPicts1: allImageSharp(
      filter: { id: { regex: "/images/home-grid-001-desktop/" } },
      sort: { order: ASC, fields: [id]}
  ) {
      edges {
        node {
          sizes(maxWidth: 1400,) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
    gridPicts1_mobile: allImageSharp(
      filter: { id: { regex: "/images/home-grid-001-mobile/" } },
      sort: { order: ASC, fields: [id]}
  ) {
      edges {
        node {
          sizes(maxWidth: 1400,) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
    gridPicts2: allImageSharp(
      filter: { id: { regex: "/images/home-grid-002-desktop/" } },
      sort: { order: ASC, fields: [id]}
  ) {
      edges {
        node {
          sizes(maxWidth: 1400,) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
    gridPicts2_mobile: allImageSharp(
      filter: { id: { regex: "/images/home-grid-002-mobile/" } },
      sort: { order: ASC, fields: [id]}
  ) {
      edges {
        node {
          sizes(maxWidth: 1400,) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
    gridPicts3: allImageSharp(
      filter: { id: { regex: "/images/home-grid-003-desktop/" } },
      sort: { order: ASC, fields: [id]}
  ) {
      edges {
        node {
          sizes(maxWidth: 1400,) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
    gridPicts3_mobile: allImageSharp(
      filter: { id: { regex: "/images/home-grid-003-mobile/" } },
      sort: { order: ASC, fields: [id]}
  ) {
      edges {
        node {
          sizes(maxWidth: 1400,) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
    gridPicts4: allImageSharp(
      filter: { id: { regex: "/images/home-grid-004-desktop/" } },
      sort: { order: ASC, fields: [id]}
  ) {
      edges {
        node {
          sizes(maxWidth: 1400,) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
    gridPicts4_mobile: allImageSharp(
      filter: { id: { regex: "/images/home-grid-004-mobile/" } },
      sort: { order: ASC, fields: [id]}
  ) {
      edges {
        node {
          sizes(maxWidth: 1400,) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/home-page.js